import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Global } from '@emotion/react';
const css = String.raw;
const CUSTOM_STYLES_ATTR = 'data-cb-immersive-experience-root';
/**
 * This component searches for style tags with the specified attribute and applied them as Global styles,
 * to prevent issues with intentional overrides that don't work because of the order in which the styles are added in the head.
 * This feature will be more useful in the future when we implement the ShadowDOM.
 */
export const CustomStylesLoader = () => {
    const [styles, setStyles] = useState([]);
    useEffect(() => {
        const styles = document.querySelectorAll(`style[${CUSTOM_STYLES_ATTR}]`) || [];
        setStyles(Array.from(styles).map((style) => style.innerHTML));
    }, []);
    return (_jsx(_Fragment, { children: styles.map((style, index) => (_jsx(Global, { styles: css `${style}` }, index))) }));
};
